/*
  example: 
  Profile Component has a fieldValidations object such as
  fieldValidations = {...., Age: ruleRunner("Age", "Age", [isValidAge(0, 120)])}
  field = "Age", name = "Age", validations = [isValidAge(0, 120)]
  isValidAge returns a function with the min and max value defined as 0 and 120,
  it will take the age as a parameter, making sure it is the correct number
  ruleRunner will return a function which requires a state to be passed in
  it will loop through the validations array (our example is just isValidAge(0, 120))
  and errorMessageFunc will hold the result of each validation entry, passing in
  state[field], and the state.
  This example will be errorMessageFunc = v(state[Age], state)
  v being the function returned in line 174 in rules.ts
*/
export const ruleRunner = (field, name, validations) => {
  return (state) => {
    const obj = {};
    for (const v of validations) {
      const errorMessageFunc = v(state[field], state);
      if (errorMessageFunc) {
        obj[field] = errorMessageFunc(name);
      }
    }
    return obj;
  };
};

/*
  const obj = {}
  loop once, because array only has one item (result of isValidAge function)
  if valid, should return empty string ""
  const errorMessageFunc = isValidAge(currentInvestor[Age], currentInvestor)
  if the age is valid, it will return an empty string, otherwise will place the error message into the object
*/

/*
  In Profile Component,
  state = currentInvestorState, runners = [fieldValidations[field]]
  fieldValidations is the object containing the FirstName, LastName, Age, and EmailAddress properties, where each
  one contains a function needing a state to be passed in it
  In this example, it will be [fieldValidations["Age"]] -> { Age: (state) => {...}}
  then Object.assign(currentInvestorState, the returned function from ruleRunner)
*/
export const run = (state, runners) => {
  return runners.reduce((memo, runner) => {
    memo = { ...runner(state) };
    return memo;
    // return Object.assign(memo, runner(state));
  }, {});
};
